<div class="registro-recepcion">
  <h3><i class="fas fa-user-plus"></i> Recepción de estudiantes</h3>
  
  <form [formGroup]="registroForm" (ngSubmit)="onSubmit()" class="registro-form">
    <div class="form-row">
      <!-- Nro Libreta -->
      <div class="form-group">
        <label for="nroLibreta">
          Nro. Libreta *
          <i *ngIf="isLoading" class="fas fa-spinner fa-spin loading-icon"></i>
        </label>
        <input type="number" 
               id="nroLibreta"
               formControlName="nroLibreta"
               placeholder="Ej: 123"
               min="1">
        <div class="field-error" *ngIf="getFieldError('nroLibreta')">
          {{ getFieldError('nroLibreta') }}
        </div>
        <div class="student-not-found" *ngIf="studentNotFound">
          ⚠️ Estudiante no encontrado en la base de datos
        </div>
      </div>

      <!-- Apellido -->
      <div class="form-group">
        <label for="apellido">Apellido *</label>
        <input type="text" 
               id="apellido"
               formControlName="apellido"
               placeholder="Ej: García">
        <div class="field-error" *ngIf="getFieldError('apellido')">
          {{ getFieldError('apellido') }}
        </div>
      </div>

      <!-- Nombre -->
      <div class="form-group">
        <label for="nombre">Nombre *</label>
        <input type="text" 
               id="nombre"
               formControlName="nombre"
               placeholder="Ej: Juan">
        <div class="field-error" *ngIf="getFieldError('nombre')">
          {{ getFieldError('nombre') }}
        </div>
      </div>
    </div>

    <div class="form-row">
      <!-- Instructor -->
      <div class="form-group">
        <label for="idInstructor">Instructor *</label>
        <select id="idInstructor" formControlName="idInstructor">
          <option value="">Seleccione instructor</option>
          <option *ngFor="let instructor of instructores$ | async" [value]="instructor.id">
            {{ instructor.nombre }} {{ instructor.apellido }}{{ !instructor.activo ? ' - INACTIVO' : '' }}
          </option>
        </select>
        <div class="field-error" *ngIf="getFieldError('idInstructor')">
          {{ getFieldError('idInstructor') }}
        </div>
      </div>

      <!-- Graduación Actual -->
      <div class="form-group">
        <label for="idGraduacionActual">Graduación Actual *</label>
        <select id="idGraduacionActual" formControlName="idGraduacionActual">
          <option value="">Seleccione graduación actual</option>
          <option *ngFor="let graduacion of graduaciones$ | async" [value]="graduacion.id">
            {{ graduacion.descripcion }}
          </option>
        </select>
        <div class="field-error" *ngIf="getFieldError('idGraduacionActual')">
          {{ getFieldError('idGraduacionActual') }}
        </div>
      </div>

      <!-- Graduación Examen -->
      <div class="form-group">
        <label for="idGraduacionExamen">Graduación Examen *</label>
        <select id="idGraduacionExamen" formControlName="idGraduacionExamen">
          <option value="">Seleccione graduación de examen</option>
          <option *ngFor="let graduacion of graduaciones$ | async" [value]="graduacion.id">
            {{ graduacion.descripcion }}
          </option>
        </select>
        <div class="field-error" *ngIf="getFieldError('idGraduacionExamen')">
          {{ getFieldError('idGraduacionExamen') }}
        </div>
      </div>
    </div>
    <!-- Caja Section -->
    <div class="form-section">
      <h4 class="section-title">
        <i class="fas fa-cash-register"></i> Caja
        <div class="total-display">
          Total: <span class="total-amount">${{ totalPago | number }}</span>
        </div>
      </h4>
      
      <div class="form-row">
        <!-- Examen -->
        <div class="form-group">
          <div class="checkbox-group">
            <label class="checkbox-container">
              <input type="checkbox" [(ngModel)]="incluyeExamen" (change)="calcularTotal()" [ngModelOptions]="{standalone: true}">
            <span class="checkbox-label">Examen (${{ preciosExamen.examen | number }})</span>
            </label>
          </div>
        </div>
        
        <!-- Libreta -->
        <div class="form-group">
          <div class="checkbox-group">
            <label class="checkbox-container">
              <input type="checkbox" [(ngModel)]="incluyeLibreta" (change)="calcularTotal()" [ngModelOptions]="{standalone: true}">
              <span class="checkbox-label">Libreta (${{ preciosExamen.libreta | number }})</span>
            </label>
          </div>
        </div>
        
        <!-- Indumentaria -->
        <div class="form-group">
          <label for="indumentaria">Indumentaria:</label>
          <div class="precio-input">
            <span class="precio-symbol">$</span>
            <input type="number" 
                  id="indumentaria" 
                  [(ngModel)]="precioIndumentaria" 
                  (input)="calcularTotal()"
                  [ngModelOptions]="{standalone: true}"
                  min="0" 
                  step="1000">
          </div>
        </div>
      </div>

      <!-- Indumentaria Description - Show only when indumentaria has value -->
      <div class="form-row" *ngIf="precioIndumentaria > 0">
        <div class="form-group full-width">
          <label for="indumentariaDescripcion">Descripción de Indumentaria:</label>
          <input type="text" 
                 id="indumentariaDescripcion" 
                 [(ngModel)]="indumentariaDescripcion" 
                 [ngModelOptions]="{standalone: true}"
                 placeholder="Ej: Dobok, Cinturón, etc.">
        </div>
      </div>
      
      <!-- Maderas Section - Collapsible -->
      <div class="maderas-section">
        <div class="maderas-header" (click)="toggleMaderasSection()">
          <h5>Maderas</h5>
          <i class="fas" [ngClass]="maderasSectionExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
        
        <div class="maderas-content" [class.collapsed]="!maderasSectionExpanded">
          <div class="maderas-controls">
            <div class="madera-select" *ngFor="let madera of preciosExamen.maderas">
              <div class="madera-info">
                <span class="madera-name">{{ madera.nombre }}</span>
                <span class="madera-price">${{ madera.precio | number }}</span>
              </div>
              <div class="madera-actions">
                <button type="button" class="madera-btn remove" (click)="quitarMadera(madera)">
                  <i class="fas fa-minus"></i>
                </button>
                <span class="madera-cantidad">
                  {{ (maderasSeleccionadas | findMadera:madera.id)?.cantidad || 0 }}
                </span>
                <button type="button" class="madera-btn add" (click)="agregarMadera(madera)">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Selected maderas summary -->
          <div class="maderas-summary" *ngIf="maderasSeleccionadas.length > 0">
            <div class="summary-title">Seleccionadas:</div>
            <div class="summary-items">
              <div class="summary-item" *ngFor="let item of maderasSeleccionadas">
                {{ item.tipo.nombre }} x{{ item.cantidad }}
                <span class="summary-price">${{ item.tipo.precio * item.cantidad | number }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Discount and Payment Method Section -->
      <div class="form-row">
        <!-- Discount Column (Half column) -->
        <div class="form-group">
          <label class="discount-header-label" (click)="toggleIndividualDiscounts()">
            Descuento % / Final $
            <i class="fas" [ngClass]="showIndividualDiscounts ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </label>
          
          <div class="discount-input-container">
            <!-- Total Discount (Visible when not showing individual ones) -->
            <div class="total-discount-view" *ngIf="!showIndividualDiscounts">
              <div class="dual-input">
                <input type="number" 
                       id="descuentoPorcentaje" 
                       [(ngModel)]="descuentoPorcentaje" 
                       (input)="calcularTotal()"
                       [ngModelOptions]="{standalone: true}"
                       min="0" 
                       max="100"
                       step="0.01"
                       placeholder="0 %">
                <span class="input-separator">➔</span>
                <div class="precio-input">
                  <span class="precio-symbol">$</span>
                  <input type="number" 
                         [(ngModel)]="totalPago" 
                         (change)="onTotalPagoChange()"
                         [ngModelOptions]="{standalone: true}"
                         placeholder="Final"
                         step="5000">
                </div>
              </div>
            </div>

            <!-- Individual Discounts (Dropdown content) -->
            <div class="individual-discounts-content" [class.collapsed]="!showIndividualDiscounts">
              <!-- Examen Individual -->
              <div class="individual-discount-row" *ngIf="incluyeExamen">
                <label>Examen:</label>
                <div class="dual-input">
                  <input type="number" [(ngModel)]="descExamenPct" (input)="calcularTotal()" [ngModelOptions]="{standalone: true}" placeholder="%" step="0.01" min="0" max="100">
                  <span class="input-separator">➔</span>
                  <div class="precio-input">
                    <span class="precio-symbol">$</span>
                    <input type="number" [(ngModel)]="valorExamen" (change)="onIndividualValueChange('examen')" [ngModelOptions]="{standalone: true}" step="5000">
                  </div>
                </div>
              </div>

              <!-- Libreta Individual -->
              <div class="individual-discount-row" *ngIf="incluyeLibreta">
                <label>Libreta:</label>
                <div class="dual-input">
                  <input type="number" [(ngModel)]="descLibretaPct" (input)="calcularTotal()" [ngModelOptions]="{standalone: true}" placeholder="%" step="0.01" min="0" max="100">
                  <span class="input-separator">➔</span>
                  <div class="precio-input">
                    <span class="precio-symbol">$</span>
                    <input type="number" [(ngModel)]="valorLibreta" (change)="onIndividualValueChange('libreta')" [ngModelOptions]="{standalone: true}" step="5000">
                  </div>
                </div>
              </div>

              <!-- Maderas Individual -->
              <div class="individual-discount-row" *ngIf="maderasSeleccionadas.length > 0">
                <label>Maderas:</label>
                <div class="dual-input">
                  <input type="number" [(ngModel)]="descMaderasPct" (input)="calcularTotal()" [ngModelOptions]="{standalone: true}" placeholder="%" step="0.01" min="0" max="100">
                  <span class="input-separator">➔</span>
                  <div class="precio-input">
                    <span class="precio-symbol">$</span>
                    <input type="number" [(ngModel)]="valorMaderas" (change)="onIndividualValueChange('maderas')" [ngModelOptions]="{standalone: true}" step="5000">
                  </div>
                </div>
              </div>

              <!-- Indumentaria Individual -->
              <div class="individual-discount-row" *ngIf="precioIndumentaria > 0">
                <label>Indumentaria:</label>
                <div class="dual-input">
                  <input type="number" [(ngModel)]="descIndumentariaPct" (input)="calcularTotal()" [ngModelOptions]="{standalone: true}" placeholder="%" step="0.01" min="0" max="100">
                  <span class="input-separator">➔</span>
                  <div class="precio-input">
                    <span class="precio-symbol">$</span>
                    <input type="number" [(ngModel)]="valorIndumentaria" (change)="onIndividualValueChange('indumentaria')" [ngModelOptions]="{standalone: true}" step="5000">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Method Column (Half column, always visible) -->
        <div class="form-group">
          <label for="medioDePago">Medio de Pago:</label>
          <select id="medioDePago" [(ngModel)]="medioDePago" [ngModelOptions]="{standalone: true}">
            <option value="Efectivo">Efectivo</option>
            <option value="Debito">Débito</option>
            <option value="Credito">Crédito</option>
            <option value="Transferencia">Transferencia</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Messages -->
    <div class="messages">
      <div class="error-message" *ngIf="errorMessage">
        <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
      </div>
      <div class="success-message" *ngIf="successMessage">
        <i class="fas fa-check-circle"></i> {{ successMessage }}
      </div>
    </div>

    <!-- Form actions -->
    <div class="form-actions">
      <button type="button" 
              (click)="clearForm()" 
              class="clear-btn">
        <i class="fas fa-eraser"></i> Limpiar
      </button>
      <button type="submit" 
              [disabled]="!registroForm.valid || isLoading"
              class="submit-btn">
        <i class="fas fa-plus"></i> Agregar Estudiante
      </button>
    </div>
  </form>
</div>